module.exports = "https://static.wmbcdn.com/uniweb/images/7133501962210750e6e0f4fc4b6ebc46.svg";